import React, { useEffect } from 'react';
import { ArrowLeft, Mail, Globe, FileText } from 'lucide-react';
const OPERATOR = {
  name: 'Индивидуальный предприниматель Федин Андрей Дмитриевич',
  shortName: 'ИП Федин Андрей Дмитриевич',
  inn: '590310476707',
  email: 'info@2opinion-online.ru',
  site: '2opinion-online.ru',
  siteUrl: 'https://2opinion-online.ru',
  policyUrl: 'https://2opinion-online.ru/#/privacy',
  effectiveDate: '01.01.2026'
};
const sections = [{
  id: 'general',
  num: '1',
  title: 'Общие положения',
  body: <>
        <p data-id="element-356">
          Политика в отношении обработки персональных данных{' '}
          <strong data-id="element-357">{OPERATOR.shortName}</strong> (ИНН {OPERATOR.inn}) (далее —{' '}
          <em data-id="element-358">«Оператор»</em>) разработана в соответствии с требованиями ч. 2
          ст. 18.1 Федерального закона от 27 июля 2006 г. № 152-ФЗ «О
          персональных данных» (далее — <em data-id="element-359">«Федеральный закон №152-ФЗ»</em>) и
          предназначена для предоставления неограниченного доступа к информации
          в отношении обработки персональных данных, а также к сведениям о
          реализуемых требованиях к защите персональных данных Оператора.
        </p>
        <p data-id="element-360">
          Настоящая Политика описывает порядок обработки и защиты персональных
          данных физических лиц (далее — <em data-id="element-361">«Пользователи»</em>), использующих:
        </p>
        <ul data-id="element-362">
          <li data-id="element-363">
            сайт Оператора{' '}
            <a href={OPERATOR.siteUrl} className="text-sage underline hover:no-underline" data-id="element-364">
              {OPERATOR.site}
            </a>{' '}
            или его поддомены вида <code data-id="element-365">*.{OPERATOR.site}</code> (далее —{' '}
            <em data-id="element-366">«Сайт»</em>);
          </li>
          <li data-id="element-367">
            программы, страницы в соцсетях и мессенджерах, чат-боты, сервисы и
            иные ресурсы в сети Интернет, предоставляемые Оператором для
            информирования Пользователей о деятельности Оператора (далее —{' '}
            <em data-id="element-368">«Ресурсы»</em>).
          </li>
        </ul>
        <p data-id="element-369">
          Персональные данные относятся к категории конфиденциальной информации
          и защищены от несанкционированного, в том числе случайного, доступа к
          ним.
        </p>
        <p data-id="element-370">
          Политика применяется исключительно к Сайту и Ресурсам. Оператор не
          контролирует и не несёт ответственность за сайты и ресурсы третьих
          лиц, на которые Пользователь может перейти по ссылкам, доступным на
          Сайте и на Ресурсах.
        </p>
        <p data-id="element-371">
          Политика опубликована для неограниченного доступа на Сайте Оператора
          по адресу:{' '}
          <a href={OPERATOR.policyUrl} className="text-sage underline hover:no-underline" data-id="element-372">
            {OPERATOR.policyUrl}
          </a>
          .
        </p>
      </>
}, {
  id: 'legal-basis',
  num: '2',
  title: 'Правовые основания обработки персональных данных',
  body: <>
        <p data-id="element-373">
          <strong data-id="element-374">2.1.</strong> Сбор и последующая обработка персональных данных
          Оператором допускаются только после получения конкретного,
          предметного, информированного, сознательного и однозначного согласия
          на обработку персональных данных, предоставленного Пользователем
          свободно, своей волей и в своём интересе (далее — <em data-id="element-375">«Согласие»</em>
          ).
        </p>
        <p data-id="element-376">
          <strong data-id="element-377">2.2.</strong> Оператор производит обработку и обеспечивает
          защиту персональных данных Пользователей, которые выразили своё
          Согласие при отправке на Сайте формы нажав кнопку «Отправить», кнопку
          «Согласен/а» через чат-бот Оператора.
        </p>
        <p data-id="element-378">
          <strong data-id="element-379">2.3.</strong> Согласие может быть в любое время отозвано
          Пользователем путём личного или письменного обращения Пользователя или
          его представителя с заявлением об отзыве Согласия в свободной форме на
          электронный адрес Оператора{' '}
          <a href={`mailto:${OPERATOR.email}`} className="text-sage underline hover:no-underline" data-id="element-380">
            {OPERATOR.email}
          </a>
          .
        </p>
        <p data-id="element-381">
          <strong data-id="element-382">2.4.</strong> Оператор может осуществлять обработку
          персональных данных без согласия Пользователя (в том числе, после
          отзыва Согласия) в следующих случаях:
        </p>
        <ul data-id="element-383">
          <li data-id="element-384">
            обработка персональных данных необходима для осуществления прав и
            законных интересов Оператора для достижения общественно значимых
            целей при условии, что при этом не нарушаются права и свободы
            Пользователя;
          </li>
          <li data-id="element-385">
            обработка персональных данных необходима для заключения и исполнения
            договора;
          </li>
          <li data-id="element-386">
            обработка персональных данных осуществляется в статистических или
            иных исследовательских целях, при условии обязательного
            обезличивания персональных данных;
          </li>
          <li data-id="element-387">
            персональные данные должны быть опубликованы или раскрыты в
            соответствии с федеральными законами, в том числе по требованиям
            уполномоченных должностных лиц;
          </li>
          <li data-id="element-388">
            в иных случаях, прямо предусмотренных Федеральным законом №152-ФЗ.
          </li>
        </ul>
      </>
}, {
  id: 'order',
  num: '3',
  title: 'Порядок и условия обработки персональных данных',
  body: <>
        <p data-id="element-389">
          <strong data-id="element-390">3.1.</strong> Цели обработки персональных данных с указанием
          категорий субъекта персональных данных, категорий и перечня
          персональных данных в отношении каждой цели обработки определены в
          разделе 4 Политики.
        </p>
        <p data-id="element-391">
          <strong data-id="element-392">3.2.</strong> Оператор осуществляет автоматизированную,
          неавтоматизированную (без использования средств автоматизации) и
          смешанную обработку с передачей по сети Интернет, включая сбор,
          запись, систематизацию, накопление, хранение, уточнение (обновление,
          изменение), извлечение, использование, передачу (распространение,
          предоставление, доступ), блокирование, удаление, уничтожение
          персональных данных.
        </p>
        <p data-id="element-393">
          <strong data-id="element-394">3.3.</strong> Сбор персональных данных осуществляется
          непосредственно у Пользователя. Если предоставление персональных
          данных и (или) получение Оператором согласия на обработку персональных
          данных являются обязательными в соответствии с законодательством
          Российской Федерации, субъекту персональных данных разъясняются
          юридические последствия отказа в предоставлении таких данных и (или)
          согласия на их обработку.
        </p>
        <p data-id="element-395">
          <strong data-id="element-396">3.4.</strong> Получение персональных данных у иных лиц
          возможно только при наличии законных оснований. При получении
          персональных данных у иных лиц, за исключением случаев, когда
          персональные данные получены в рамках поручения на обработку
          персональных данных или когда согласие получено передающей стороной,
          необходимо уведомить об этом субъекта.
        </p>
        <p data-id="element-397">
          <strong data-id="element-398">3.5.</strong> Обработка биометрических персональных данных и
          специальных категорий персональных данных, касающихся расовой,
          национальной принадлежности, политических взглядов, религиозных или
          философских убеждений, состояния здоровья, интимной жизни, на Сайте и
          на Ресурсах не осуществляется.
        </p>
        <p data-id="element-399">
          <strong data-id="element-400">3.6.</strong> Передача персональных данных Пользователя
          третьим лицам, в том числе лицам, осуществляющим обработку
          персональных данных по поручению Оператора, осуществляется Оператором
          в соответствии с Федеральным законом №152-ФЗ с согласия Пользователя.
        </p>
        <p data-id="element-401">
          <strong data-id="element-402">3.7.</strong> Для достижения целей обработки персональных
          данных, указанных в разделе 4 Политики, а также для обеспечения
          технической защищённости персональных данных Оператору требуется
          использовать различные информационные системы и средства
          автоматизации. Оператор привлекает технических посредников для
          оказания ему соответствующих услуг. В рамках взаимодействия с
          техническими посредниками Оператор передаёт персональные данные
          Пользователей третьим лицам, а также поручает обработку персональных
          данных третьим лицам на основании договора. Оператор передаёт
          персональные данные Пользователей только в том объёме, в каком они
          необходимы третьим лицам для оказания услуг.
        </p>
        <p data-id="element-403">
          <strong data-id="element-404">3.8.</strong> Третьи лица обязаны обеспечивать
          конфиденциальность в отношении персональных данных, а также принимать
          необходимые организационные, юридические и технические меры защиты. Ни
          при каких обстоятельствах третьи лица не должны осуществлять обработку
          персональных данных Пользователей для целей, не предусмотренных в
          разделе 4 Политики. Для получения информации о конкретном перечне
          третьих лиц Пользователь может направить письменный запрос Оператору в
          свободной форме по адресу электронной почты{' '}
          <a href={`mailto:${OPERATOR.email}`} className="text-sage underline hover:no-underline" data-id="element-405">
            {OPERATOR.email}
          </a>
          .
        </p>
        <p data-id="element-406">
          <strong data-id="element-407">3.9.</strong> Трансграничная передача персональных данных
          Пользователя не осуществляется Оператором.
        </p>
        <p data-id="element-408">
          <strong data-id="element-409">3.10.</strong> Срок обработки Оператором персональных данных
          соответствует сроку, необходимому для достижения целей обработки,
          указанных в разделе 4 Политики.
        </p>
        <p data-id="element-410">
          <strong data-id="element-411">3.11.</strong> Хранение персональных данных Оператором
          осуществляется в форме, позволяющей определить Пользователя не дольше,
          чем этого требуют цели их обработки, указанные в разделе 4 Политики,
          если срок хранения персональных данных не установлен федеральным
          законом, договором, стороной которого, выгодоприобретателем или
          поручителем, по которому является Пользователь.
        </p>
        <p data-id="element-412">
          <strong data-id="element-413">3.12.</strong> При сборе персональных данных Оператором
          обеспечивается запись, систематизация, накопление, хранение, уточнение
          (обновление, изменение), извлечение персональных данных граждан
          Российской Федерации с использованием баз данных, находящихся на
          территории Российской Федерации. При этом в указанном случае не
          используются базы данных, находящиеся за пределами территории
          Российской Федерации.
        </p>
        <p data-id="element-414">
          <strong data-id="element-415">3.13.</strong> Обрабатываемые персональные данные подлежат
          уничтожению либо обезличиванию при наступлении следующих условий:
        </p>
        <ul data-id="element-416">
          <li data-id="element-417">
            достижение целей обработки персональных данных или максимальных
            сроков хранения;
          </li>
          <li data-id="element-418">
            утрата необходимости в достижении целей обработки персональных
            данных;
          </li>
          <li data-id="element-419">выявлена неправомерная обработка персональных данных;</li>
          <li data-id="element-420">ликвидация (реорганизация) Оператора;</li>
          <li data-id="element-421">отзыв Согласия Пользователем.</li>
        </ul>
        <p data-id="element-422">
          <strong data-id="element-423">3.14.</strong> Уничтожение персональных данных означает
          действия Оператора, в результате которых становится невозможным
          восстановить содержание персональных данных и (или) в результате
          которых уничтожаются носители персональных данных. Уничтожение
          осуществляется способом, обеспечивающим гарантированное уничтожение
          (без возможности восстановления). Подтверждение уничтожения
          производится и оформляется в соответствии с Приказом Роскомнадзора от
          28.10.2022 № 179.
        </p>
        <p data-id="element-424">
          <strong data-id="element-425">3.15.</strong> При невозможности уничтожения персональных
          данных в сроки, определённые Федеральным законом №152-ФЗ для отдельных
          случаев, Оператор осуществляет блокирование персональных данных и
          уничтожает их в течение 6 (шести) месяцев, если иной срок не
          установлен законодательством.
        </p>
      </>
}];
const purposes = [{
  title: 'Обработка входящих запросов Пользователей',
  desc: 'Консультирование о деятельности Оператора, оформление заявок.',
  subjects: 'Пользователи, заполнившие форму с кнопкой «Отправить» на Сайте или отправившие свои данные на Ресурсах Оператора (в частности, в чат-боте).',
  data: ['Имя', 'Номер телефона', 'Адрес электронной почты (e-mail)'],
  method: 'Смешанная обработка с передачей по сети Интернет. Сроки хранения — по пункту 3.11 Политики. Уничтожение — по пунктам 3.13–3.14.'
}, {
  title: 'Информирование о деятельности, новостях и предложениях',
  desc: 'Отправка сервисных и маркетинговых сообщений Оператора.',
  subjects: 'Пользователи, заполнившие форму с кнопкой «Отправить» на Сайте или отправившие свои данные на Ресурсах Оператора.',
  data: ['Имя', 'Адрес электронной почты (e-mail)', 'Телефон'],
  method: 'Смешанная обработка с передачей по сети Интернет. Сроки хранения — по пункту 3.11 Политики.'
}, {
  title: 'Аналитика действий Пользователя на Сайте',
  desc: 'Анализ функционирования Сайта и улучшение пользовательского опыта.',
  subjects: 'Пользователи, выразившие согласие на использование cookies-файлов при входе на Сайт.',
  data: ['Характеристики устройства и браузера', 'Операционная система', 'Языковые предпочтения', 'Местоположение, время и продолжительность использования Сайта', 'Посещённые страницы Сайта', 'Иные сведения о том, как Пользователь использует Сайт'],
  method: 'Автоматизированная обработка с использованием сервисов веб-аналитики. Сроки хранения соответствуют срокам хранения cookie-файлов.'
}];
const userRights = ['отозвать своё Согласие на обработку персональных данных;', 'получить у Оператора информацию касательно обработки своих персональных данных;', 'требовать устранения нарушений законодательства, допущенных при обработке персональных данных;', 'требовать уточнения своих персональных данных, их блокирования или уничтожения в случае, если, по мнению Пользователя, данные являются неполными, устаревшими, неточными, незаконно полученными или не являются необходимыми для заявленной цели обработки;', 'обладать иными правами, предусмотренными законодательством.'];
const operatorObligations = ['в случае достижения цели обработки персональных данных прекратить обработку персональных данных и уничтожить их;', 'в случае отзыва Пользователем согласия на обработку его персональных данных, прекратить их обработку, если отсутствует иное законное основание обработки, и в случае, если сохранение персональных данных более не требуется для целей обработки, уничтожить их;', 'не раскрывать третьим лицам и не распространять персональные данные без согласия Пользователя, если иное не предусмотрено законодательством;', 'не допускать при сборе персональных данных осуществление записи, систематизации, накопления, хранения, уточнения (обновления, изменения), извлечения персональных данных граждан Российской Федерации с использованием баз данных, находящихся за пределами территории Российской Федерации;', 'обеспечить точность, достаточность, а в необходимых случаях и актуальность персональных данных при их обработке;', 'принимать необходимые правовые, организационные и технические меры по обеспечению безопасности персональных данных при их обработке;', 'предоставлять Пользователю по его просьбе информацию, касающуюся обработки его персональных данных, предусмотренную ч. 7 ст. 14 Федерального закона №152-ФЗ;', 'разъяснить Пользователю юридические последствия отказа предоставить его персональные данные и (или) дать согласие на их обработку, если предоставление персональных данных и (или) получение Оператором согласия на обработку персональных данных являются обязательными;', 'устранять нарушения законодательства, допущенные при обработке персональных данных, уточнять, блокировать и уничтожать персональные данные в случаях, установленных законодательством о персональных данных;', 'выполнять иные требования законодательства.'];
export const Privacy = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return <div className="min-h-screen bg-offwhite" data-id="element-426">
      {/* Top bar */}
      <header className="border-b border-beige bg-offwhite/90 backdrop-blur-md sticky top-0 z-40" data-id="element-427">
        <div className="max-w-4xl mx-auto px-6 py-5 flex items-center justify-between" data-id="element-428">
          <a href="#/" className="flex items-center gap-2 group" data-id="element-429">
            <div className="w-8 h-8 rounded-full bg-sage flex items-center justify-center" data-id="element-430">
              <div className="w-3 h-3 rounded-full bg-offwhite" data-id="element-431" />
            </div>
            <span className="font-serif font-medium text-xl tracking-tight text-navy" data-id="element-432">
              Консилиум
            </span>
          </a>
          <a href="#/" className="inline-flex items-center gap-2 text-sm text-navyLight hover:text-sage transition-colors" data-id="element-433">
            <ArrowLeft size={16} data-id="element-434" />
            На главную
          </a>
        </div>
      </header>

      <main className="max-w-4xl mx-auto px-6 py-12 md:py-20" data-id="element-435">
        {/* Hero */}
        <div className="mb-12 md:mb-16" data-id="element-436">
          <span className="inline-block text-xs font-medium tracking-[0.2em] uppercase text-sage mb-4" data-id="element-437">
            Документ
          </span>
          <h1 className="font-serif text-4xl md:text-5xl lg:text-6xl text-navy leading-[1.05] mb-6" data-id="element-438">
            Политика в отношении обработки персональных данных
          </h1>
          <p className="text-navyLight text-lg leading-relaxed max-w-2xl" data-id="element-439">
            Документ описывает порядок обработки и защиты персональных данных
            пользователей Сайта и Ресурсов Оператора в соответствии с
            Федеральным законом №152-ФЗ.
          </p>
        </div>

        {/* Operator card */}
        <div className="bg-beigeLight rounded-3xl p-8 md:p-10 mb-12 border border-beige/60" data-id="element-440">
          <div className="flex items-center gap-3 mb-6" data-id="element-441">
            <div className="w-10 h-10 rounded-full bg-sage/15 flex items-center justify-center" data-id="element-442">
              <FileText size={18} className="text-sage" data-id="element-443" />
            </div>
            <h2 className="font-serif text-xl md:text-2xl text-navy" data-id="element-444">
              Реквизиты Оператора
            </h2>
          </div>
          <dl className="grid sm:grid-cols-2 gap-x-8 gap-y-5 text-sm" data-id="element-445">
            <div data-id="element-446">
              <dt className="text-xs uppercase tracking-wider text-navyLight/70 mb-1.5" data-id="element-447">
                Наименование
              </dt>
              <dd className="text-navy font-medium leading-relaxed" data-id="element-448">
                {OPERATOR.shortName}
              </dd>
            </div>
            <div data-id="element-449">
              <dt className="text-xs uppercase tracking-wider text-navyLight/70 mb-1.5" data-id="element-450">
                ИНН
              </dt>
              <dd className="text-navy font-medium leading-relaxed" data-id="element-451">
                {OPERATOR.inn}
              </dd>
            </div>
            <div data-id="element-452">
              <dt className="text-xs uppercase tracking-wider text-navyLight/70 mb-1.5 flex items-center gap-1.5" data-id="element-453">
                <Mail size={12} data-id="element-454" /> Электронная почта
              </dt>
              <dd data-id="element-455">
                <a href={`mailto:${OPERATOR.email}`} className="text-sage hover:underline font-medium" data-id="element-456">
                  {OPERATOR.email}
                </a>
              </dd>
            </div>
            <div data-id="element-457">
              <dt className="text-xs uppercase tracking-wider text-navyLight/70 mb-1.5 flex items-center gap-1.5" data-id="element-458">
                <Globe size={12} data-id="element-459" /> Сайт
              </dt>
              <dd data-id="element-460">
                <a href={OPERATOR.siteUrl} className="text-sage hover:underline font-medium" data-id="element-461">
                  {OPERATOR.site}
                </a>
              </dd>
            </div>
          </dl>
        </div>

        {/* Table of contents */}
        <nav aria-label="Оглавление" className="mb-14 bg-white border border-beige rounded-2xl p-6 md:p-8" data-id="element-462">
          <h2 className="text-xs font-medium tracking-[0.2em] uppercase text-sage mb-4" data-id="element-463">
            Содержание
          </h2>
          <ol className="space-y-2 text-navyLight" data-id="element-464">
            {[['general', '1. Общие положения'], ['legal-basis', '2. Правовые основания обработки'], ['order', '3. Порядок и условия обработки'], ['purposes', '4. Цели обработки персональных данных'], ['rights', '5. Основные права Пользователя'], ['obligations', '6. Основные обязанности Оператора'], ['cookies', '7. Использование cookie-файлов'], ['final', '8. Заключительные положения']].map(([id, label]) => <li key={id} data-id="element-465">
                <a href={`#${id}`} className="text-sm hover:text-sage transition-colors" data-id="element-466">
                  {label}
                </a>
              </li>)}
          </ol>
        </nav>

        {/* Sections 1-3 */}
        {sections.map(s => <Section key={s.id} id={s.id} num={s.num} title={s.title} data-id="element-467">
            {s.body}
          </Section>)}

        {/* Section 4 — purposes */}
        <Section id="purposes" num="4" title="Цели обработки персональных данных" data-id="element-468">
          <div className="not-prose grid gap-5 my-2" data-id="element-469">
            {purposes.map((p, i) => <div key={i} className="bg-white border border-beige rounded-2xl p-6 md:p-7" data-id="element-470">
                <h3 className="font-serif text-xl text-navy mb-2" data-id="element-471">{p.title}</h3>
                <p className="text-navyLight text-sm leading-relaxed mb-5" data-id="element-472">
                  {p.desc}
                </p>
                <div className="grid md:grid-cols-2 gap-5 text-sm" data-id="element-473">
                  <div data-id="element-474">
                    <div className="text-xs uppercase tracking-wider text-navyLight/70 mb-2" data-id="element-475">
                      Категории субъектов
                    </div>
                    <p className="text-navy/90 leading-relaxed" data-id="element-476">{p.subjects}</p>
                  </div>
                  <div data-id="element-477">
                    <div className="text-xs uppercase tracking-wider text-navyLight/70 mb-2" data-id="element-478">
                      Категории и перечень данных
                    </div>
                    <ul className="space-y-1 text-navy/90" data-id="element-479">
                      {p.data.map((d, j) => <li key={j} className="flex gap-2" data-id="element-480">
                          <span className="text-sage shrink-0" data-id="element-481">•</span>
                          <span data-id="element-482">{d}</span>
                        </li>)}
                    </ul>
                  </div>
                </div>
                <div className="mt-5 pt-5 border-t border-beige/80" data-id="element-483">
                  <div className="text-xs uppercase tracking-wider text-navyLight/70 mb-2" data-id="element-484">
                    Способы обработки, сроки и порядок уничтожения
                  </div>
                  <p className="text-navy/90 text-sm leading-relaxed" data-id="element-485">
                    {p.method}
                  </p>
                </div>
              </div>)}
          </div>
        </Section>

        {/* Section 5 — user rights */}
        <Section id="rights" num="5" title="Основные права Пользователя" data-id="element-486">
          <p data-id="element-487">Пользователи имеют право:</p>
          <ul data-id="element-488">
            {userRights.map((r, i) => <li key={i} data-id="element-489">{r}</li>)}
          </ul>
        </Section>

        {/* Section 6 — operator obligations */}
        <Section id="obligations" num="6" title="Основные обязанности Оператора" data-id="element-490">
          <p data-id="element-491">Оператор обязуется:</p>
          <ul data-id="element-492">
            {operatorObligations.map((o, i) => <li key={i} data-id="element-493">{o}</li>)}
          </ul>
        </Section>

        {/* Section 7 — cookies */}
        <Section id="cookies" num="7" title="Использование cookie-файлов" data-id="element-494">
          <p data-id="element-495">
            <strong data-id="element-496">7.1.</strong> Оператор осуществляет автоматический сбор
            информации о посещении и использовании Пользователями Сайта при
            помощи cookies-файлов. Для этого на Сайте используется сервис
            веб-аналитики <strong data-id="element-497">Яндекс Метрика</strong>, предоставляемый
            компанией ООО «ЯНДЕКС» (ИНН 7736207543), 119021, Россия, Москва, ул.
            Л. Толстого, 16.
          </p>
          <p data-id="element-498">
            <strong data-id="element-499">7.2.</strong> В результате использования cookie-файлов может
            быть собрана следующая информация о Пользователе: характеристики
            устройства и браузера, операционная система, языковые предпочтения,
            местоположение, время и продолжительность использования Сайта
            Пользователем, посещённые страницы Сайта и иные сведения о том, как
            Пользователь использует Сайт.
          </p>
          <p data-id="element-500">
            <strong data-id="element-501">7.3.</strong> Технические данные, полученные с помощью
            cookie-файлов, используются для безопасности и функционирования
            Сайта, для взаимодействия Пользователя с Сайтом, а также для сбора
            статистической информации об использовании Сайта в целях аналитики и
            улучшения пользовательского опыта.
          </p>
          <p data-id="element-502">
            <strong data-id="element-503">7.4.</strong> Оператор не использует cookie-файлы для сбора
            сведений, идентифицирующих личность Пользователя.
          </p>
          <p data-id="element-504">
            <strong data-id="element-505">7.5.</strong> Пользователь выражает своё согласие на
            использование cookie-файлов при первом посещении Сайта, продолжая
            использование Сайта, и в дальнейшем используя Сайт.
          </p>
          <p data-id="element-506">
            <strong data-id="element-507">7.6.</strong> Пользователь вправе отказаться от
            использования cookie-файлов при помощи изменения параметров
            cookie-файлов в настройках браузера на своём устройстве. В случае
            отключения cookie-файлов Пользователь может утратить возможность
            использования некоторых функций, сервисов и инструментов Сайта.
          </p>
        </Section>

        {/* Section 8 — final */}
        <Section id="final" num="8" title="Заключительные положения" data-id="element-508">
          <p data-id="element-509">
            <strong data-id="element-510">8.1.</strong> Политика вступает в силу{' '}
            <strong data-id="element-511">{OPERATOR.effectiveDate}</strong> и действует бессрочно до
            её замены новой версией.
          </p>
          <p data-id="element-512">
            <strong data-id="element-513">8.2.</strong> Оператор в течение действия Политики вправе
            вносить в неё изменения в случае изменения законодательства, а также
            по своему усмотрению.
          </p>
          <p data-id="element-514">
            <strong data-id="element-515">8.3.</strong> Вопросы Пользователей относительно обработки
            их персональных данных или Политики, могут быть адресованы Оператору
            по адресу электронной почты{' '}
            <a href={`mailto:${OPERATOR.email}`} className="text-sage underline hover:no-underline" data-id="element-516">
              {OPERATOR.email}
            </a>
            .
          </p>
        </Section>

        {/* Footer block */}
        <div className="mt-16 pt-10 border-t border-beige text-center" data-id="element-517">
          <p className="text-sm text-navyLight mb-3" data-id="element-518">
            Действует с {OPERATOR.effectiveDate}
          </p>
          <p className="text-xs text-navyLight/60" data-id="element-519">
            {OPERATOR.shortName} · ИНН {OPERATOR.inn}
          </p>
          <a href="#/" className="inline-flex items-center gap-2 mt-8 text-sage hover:text-sageDark font-medium" data-id="element-520">
            <ArrowLeft size={16} data-id="element-521" />
            Вернуться на главную
          </a>
        </div>
      </main>
    </div>;
};
interface SectionProps {
  id: string;
  num: string;
  title: string;
  children: React.ReactNode;
}
const Section: React.FC<SectionProps> = ({
  id,
  num,
  title,
  children
}) => <section id={id} className="mb-14 scroll-mt-24" data-id="element-522">
    <div className="flex items-baseline gap-4 mb-6" data-id="element-523">
      <span className="font-serif text-sage text-2xl md:text-3xl shrink-0" data-id="element-524">
        {num}.
      </span>
      <h2 className="font-serif text-2xl md:text-3xl lg:text-4xl text-navy leading-[1.15]" data-id="element-525">
        {title}
      </h2>
    </div>
    <div className="prose-policy text-navyLight leading-relaxed space-y-4 pl-0 md:pl-10" data-id="element-526">
      {children}
    </div>
  </section>;